(function () {
  'use strict';

  /* @ngdoc object
   * @name crewBaseAssignmentReport
   * @description
   *
   */
  angular
    .module('crewBaseAssignmentReport', [
      'ui.router'
    ]);
}());
